import React, { useContext } from "react";
import { IntlContext } from "context";
import _ from "lodash";
import TableRow from "../ConstituantTable/TableRow";

export interface ValeursNutritionTableProps {
    constituants: any[];
    visible?: boolean;
}
const Table: React.FC<ValeursNutritionTableProps> = ({ constituants, visible = true }) => {
    const intl = useContext(IntlContext);
    const sources: any = [];
    const constituantsVE: HashMap<any> = {};

    const constituantRows = constituants.reduce((memo: any, constituant: any, index: number) => {
        const label = constituant?.constituant_libel;
        const value = `${constituant?.valeur_lab} ${constituant?.quantite} ${constituant?.unitemesure_vn_libel}`;

        if (_.kebabCase(label).startsWith("valeur-energetique") && constituant?.unitemesure_vn_libel) {
            constituantsVE[constituant?.unitemesure_vn_libel] = constituant;
        } else {
            memo.push(<TableRow data={[{ label, values: [value] }]} key={index} />);
        }

        if (constituant?.source_libel && !sources.includes(constituant?.source_libel)) {
            sources.push(constituant?.source_libel);
        }

        return memo;
    }, []);

    const constituantRowsVE = (constituantsVE: HashMap<any>) => {
        let label = "";
        const values: string[] = [];

        let cst = constituantsVE["kj"];
        if (cst) {
            label += ` ${cst?.unitemesure_vn_libel}`;
            values.push(`${cst?.valeur_lab} ${cst?.quantite} ${cst?.unitemesure_vn_libel}`);
        }

        cst = constituantsVE["kcal"];
        if (cst) {
            label += ` (${cst?.unitemesure_vn_libel})`;
            values.push(`${cst?.valeur_lab} ${cst?.quantite} ${cst?.unitemesure_vn_libel}`);
        }

        if (!label.length) {
            return null;
        }

        return (
            <TableRow
                data={[{ label: `${intl.formatMessage("produit.fiche.label.valeur_energetique")} ${label}`, values }]}
            />
        );
    };

    return (
        <div className={`information-table-group information-table-group--nutri-value ${!visible ? "hidden" : ""}`}>
            <p className="table-label">{constituants[0]?.uniteexpression_vn_libel}</p>
            <table className="table-information-product table-information-product--nutri-value">
                <thead className="row-group">
                    <tr className="header-row">
                        <th className="header-cell">{intl.formatMessage("produit.fiche.label.constituant")}</th>
                        <th className="header-cell">{intl.formatMessage("produit.fiche.label.quantite")}</th>
                    </tr>
                </thead>
                <tbody className="row-group">
                    {constituantRowsVE(constituantsVE)}
                    {constituantRows}
                </tbody>
            </table>
            <div className="align-right">
                {intl.formatMessage(sources.length > 1 ? "produit.fiche.label.sources" : "produit.fiche.label.source")}{" "}
                : {sources.join(", ")}
            </div>
        </div>
    );
};

export default Table;
